import { ActionItem } from '../types';
import getCurrentActionItem from './getCurrentActionItem';
import { constructUrlForActionItem } from '../components/ActionItems/ActionItems';

type Accumulator = { [key: string]: Navigation };

type Navigation = {
  previous: string | null;
  next: string | null;
  done?: { url: string; disabled: boolean };
};

function isLessonComplete(actionItems: ActionItem[]) {
  const currentActionItem = getCurrentActionItem(actionItems);

  return currentActionItem === undefined;
}

function getNavigationMap(
  actionItems: ActionItem[],
  completionUrl: string,
  urlPrefix: string
) {
  const navigationMap = actionItems.reduce(
    (accumulator: Accumulator, item, index, array) => {
      const { id } = item;

      const previousActionItem = array[index - 1];
      const nextActionItem = array[index + 1];

      const current: Navigation = {
        previous: previousActionItem
          ? constructUrlForActionItem(previousActionItem, urlPrefix)
          : null,
        next: nextActionItem
          ? constructUrlForActionItem(nextActionItem, urlPrefix)
          : null,
      };

      if (index === array.length - 1) {
        const isButtonDisabled = !isLessonComplete(actionItems);
        current.done = { url: completionUrl, disabled: isButtonDisabled };
      }

      accumulator[id] = current;

      return accumulator;
    },
    {}
  );

  return navigationMap;
}

export default getNavigationMap;
export { Navigation };
